import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function uploadBroadcastProfilePicture(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/upload/profile_pic?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body: data,
            types: [types.UPLOAD_BROADCAST_PROFILE_PICTURE_REQUEST, types.UPLOAD_BROADCAST_PROFILE_PICTURE_RECEIVE, {
                type: types.UPLOAD_BROADCAST_PROFILE_PICTURE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUploadBroadcastProfilePicture = () => ({
    type: types.RESET_UPLOAD_BROADCAST_PROFILE_PICTURE,
    payload: null
});

export function uploadChannelPicture(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/upload/channel_pic?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body: data,
            types: [types.UPLOAD_CHANNEL_PICTURE_REQUEST, types.UPLOAD_CHANNEL_PICTURE_RECEIVE, {
                type: types.UPLOAD_CHANNEL_PICTURE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUploadChannelPicture = () => ({
    type: types.RESET_UPLOAD_CHANNEL_PICTURE,
    payload: null
});

export function createBroadcasterProfile(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/create/profile?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.UPLOAD_CHANNEL_PICTURE_REQUEST, types.UPLOAD_CHANNEL_PICTURE_RECEIVE,{
                type: types.UPLOAD_CHANNEL_PICTURE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCreateBroadcasterProfile = () => ({
    type: types.RESET_UPLOAD_CHANNEL_PICTURE,
    payload: null
});

export function updateBroadcasterProfile(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/update/profile?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.UPDATE_BROADCASTER_PROFILE_REQUEST, types.UPDATE_BROADCASTER_PROFILE_RECEIVE,{
                type: types.UPDATE_BROADCASTER_PROFILE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function updatePromocode(token, api_token,data, id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/promocode/${id}?api_token=${api_token}&code=${data}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.UPDATE_PROMOCODE_REQUEST, types.UPDATE_PROMOCODE_RECEIVE,{
                type: types.UPDATE_PROMOCODE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUpdatePromoCode = () => ({
    type: types.RESET_UPDATE_PROMOCODE,
    payload: null
});

export const resetUpdateBroadcasterProfile = () => ({
    type: types.RESET_UPLOAD_CHANNEL_PICTURE,
    payload: null
});